module.exports = __webpack_public_path__ + "img/uk_failure_3.d541ed31.png";